import { Button } from '@/components/ui/button';
import { ArrowRight, Calculator } from 'lucide-react';
import { Link } from 'react-router-dom';

export const CTAFooter = () => {
  return (
    <section
      className="py-24 relative overflow-hidden"
      data-testid="cta-footer-section"
    >
      {/* Background with Gradient */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background: 'linear-gradient(135deg, #0A1628 0%, #0F2744 50%, #153A5F 100%)'
        }}
      >
        {/* Gold Accent Overlay */}
        <div className="absolute inset-0 opacity-10" style={{
          background: 'radial-gradient(circle at 30% 50%, #D4A853 0%, transparent 50%)'
        }}></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Gold Accent Line */}
        <div className="w-24 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mb-8 mx-auto"></div>
        
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white">
          Bereit für den nächsten Schritt?
        </h2>
        <p className="text-lg md:text-xl mb-10 text-gray-200 max-w-3xl mx-auto leading-relaxed">
          Vereinbaren Sie ein unverbindliches Erstgespräch oder nutzen Sie unsere
          kostenlosen Tools zur Erstbewertung Ihrer Handelsimmobilie.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/kontakt">
            <Button
              size="lg"
              data-testid="cta-footer-primary"
              className="btn-gold-gradient text-white border-0 font-semibold px-10 py-7 text-lg shadow-2xl"
            >
              Termin vereinbaren
              <ArrowRight className="ml-2 h-6 w-6" />
            </Button>
          </Link>
          <Link to="/tools/wault">
            <Button
              size="lg"
              variant="outline"
              data-testid="cta-footer-secondary"
              className="bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white hover:bg-white hover:text-[#0F2744] font-semibold px-10 py-7 text-lg transition-all duration-300"
            >
              <Calculator className="mr-2 h-6 w-6" />
              WAULT berechnen
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};